import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setPmTypeOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getCardioPacemakerTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCardioPacemakerTypeOptions])
    const { entity } = response
    yield put(setPmTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCardioPacemakerTypeOptions() error: ${e}`))
  }
}

export function* getCardioPacemakerTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCardioPacemakerTypeOptions)
}
